export default {
    routerName: '用户编辑',
    user: {
        icon: '头像',
        deptName: '部门名',
        name: '姓名',
        loginName: '账号',
        email: '邮箱',
        password: '密码',
        mobile: '电话',
        type: '用户类型',
        systemUser: '系统用户',
        normalUser: '普通用户',
        members: '会员用户',
        sex: '性别',
        status: '状态',
        remark: '备注',
        male: '男性',
        female: '女性',
        open: '开启',
        close: '停用',
        postName: '岗位',
        roleName: '角色',
    },
    info: {
        accountNotChange: '用户作成后,账号名不能在变更。',
    },
    role: {
        roleDistribute: '分配',
    },
};
